// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__C1sR5","noInteraction":"EventWrapper_noInteraction__OHCUw"};